export default "__VITE_PUBLIC_ASSET__55d85083__"